import { v4 as uuidv4 } from "uuid";

export const getDeviceId = () => {
  // Check if device ID is already stored in localStorage
  let deviceId = localStorage.getItem("deviceId");

  // If not present, generate a new one and store it
  if (!deviceId) {
    deviceId = uuidv4();
    localStorage.setItem("deviceId", deviceId);
  }

  return deviceId;
};
